import React from "react";
import { motion } from "framer-motion";
import "../styles/ArticlesSection.css";
import { Link } from "react-router-dom";

const articles = [
  {
    id: "agro-processing",
    title:
      "Agro Processing for Inclusive Growth: Leveraging Business Analytics to Empower Rural Based Manufacturers in Ghana",
    category: "AgriTech",
    region: "East Africa",
    type: "Article",
    date: "June 8, 2025",
    excerpt:
      "Ghana’s agricultural sector is rich with potential, yet a significant portion of its produce is lost due to inadequate processing and preservation.",
    image: "/agro.jpg",
  },
  {
    id: "investment",
    title:
      "Navigating the Investment Landscape and Unlocking Startup Growth: A Ghanaian Perspective",
    category: "FinTech",
    region: "West Africa",
    type: "Success Story",
    date: "June 8, 2025",
    excerpt:
      "Ghana has emerged as one of Africa’s most vibrant startup ecosystems, driven by a young, tech savvy population, increasing mobile penetration, and a growing culture of entrepreneurship.",
    image: "/growth.jpg",
  },
  {
    id: "digital-finance",
    title:
      "Digital Finance Revolution: Exploring Fintech Innovations from Ghana's Startups",
    category: "CleanTech",
    region: "Pan-Africa",
    type: "Report",
    date: "June 8, 2025",
    excerpt:
      "The financial landscape in Ghana is undergoing a radical transformation, driven by the rapid rise of financial technology (fintech) startups.",
    image: "/digital-finance.jpg",
  },
  {
    id: "farm-to-market",
    title:
      "From Farm to Market: Strengthening Value Chains for Ghana’s Smallholder Farmers",
    category: "EdTech",
    region: "Southern Africa",
    type: "Article",
    date: "June 8, 2025",
    excerpt:
      "Agriculture is the backbone of Ghana’s economy, employing nearly 45% of the workforce and contributing about 20% of GDP.",
    image: "/market.jpg",
  },
];

const BlogNewsSection = () => {
  return (
    <section className="blog-news">
      <div className="blog-header-text">
        <h2>
          <span>Blog</span> & <span className="highlight">Publications</span>
        </h2>
        <p>
          Stay updated with the latest insights, success stories, and
          developments from across Africa’s entrepreneurial ecosystem.
        </p>
      </div>

      <div className="cards">
        {articles.map((article) => (
          <motion.div
            key={article.id}
            className="card"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <img src={article.image} alt={article.title} />
            {/* <div className="card-tags">
              <span className="tag category">{article.category}</span>
              <span className="tag region">{article.region}</span>
            </div> */}
            <h3>
              <Link to={`/blog/${article.id}`}>{article.title}</Link>
            </h3>
            {/* <p>{article.excerpt}</p> */}
            <div className="card-footer">
              <span className="date">{article.date}</span>
              <Link to={`/blog/${article.id}`} className="read-more">
                Read More →
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default BlogNewsSection;
